import {API_URL,Accept} from '../constants.js';
import {notify} from 'react-notify-toast';
import api from "./api.js";
export default function notifyapi(trip_id,order_id,reason,component){
const Authorization='bearer '+localStorage.getItem('token');
  const rider_id=localStorage.getItem('rider_id');
  fetch(`${API_URL}rest/V1/rider/notifyCustomer`,{
    method:'POST',
    headers:{"Content-Type": "application/json",Accept,Authorization},
      body:JSON.stringify({
        jobId: trip_id,
        orderId: order_id,
        reason: reason
      
      })
        }).then(function(response){
          if(!response.ok){
              notify.show('Network Failure','error');
          }
            return response.json();
        })
        .then(function(data) {
            // api.callShippingJobs(component,trip_id);
    })
}



// WEBPACK FOOTER //
// ./src/utility/api/notifyapi.js